import { useQuery } from '@tanstack/react-query'
import { QueryFunctionContext } from '@tanstack/query-core'

import { buildApiUrl } from '@/api/core/url'
import post from '@/api/core/http/post'
import { TypedQueryOptions } from '@/api/core/query/options'
import { ApiError } from '@/api/core/errors'
import {
  SeasonActiveGetResponse,
  seasonActiveGetResponseSchema
} from './schema'

const path = `/arcade/season/active/get`

export const getArcadeSeasonActive = async (
  queryContext?: QueryFunctionContext
): Promise<SeasonActiveGetResponse> => {
  return post<SeasonActiveGetResponse>(
    buildApiUrl(path),
    queryContext,
    seasonActiveGetResponseSchema
  )
}

export const arcadeSeasonsQueryKey = [path, 'active'] as const

export const useArcadeSeasonActiveQuery = (
  queryOptions: TypedQueryOptions<SeasonActiveGetResponse> = {}
) => {
  return useQuery<SeasonActiveGetResponse, ApiError>(
    arcadeSeasonsQueryKey,
    queryContext => getArcadeSeasonActive(queryContext),
    {
      ...queryOptions
    }
  )
}
